

















































import { mapGetters } from 'vuex';

import {
  getAiStreamerIntegrationElevenLabsConfiguration,
  updateAiStreamerIntegrationElevenLabsConfiguration
} from '@/api/CopyStake/Settings';
import {
  TCopyStakeSettingsElevenLabsConfigurationResponse,
  TCopyStakeSettingsElevenLabsConfigurationPayload
} from '@/api/schema';

import { errorToastMessage } from '@/helpers/errorToastMessage';
import { cloneDeep, isEqual } from 'lodash';
import type { AxiosError } from 'axios';

type TSettings = {
  elevenlabsApiKey: string | null;
};

const defaultSettings = (): TSettings => ({
  elevenlabsApiKey: null
});

export default {
  name: 'CopyStakeSettingsAiStreamerIntegration',
  data(): any {
    return {
      settingsSavedData: defaultSettings(),
      settings: defaultSettings(),

      showKeys: {
        elevenlabs: false
      },

      isLoading: false,
      formValid: false
    };
  },
  props: {
    title: {
      type: String,
      default: (): string => ''
    }
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),

    canEdit(): boolean {
      return this.$role.can.update('copy_stake streamers');
    },

    settingsChanged(): boolean {
      return !isEqual(this.settings, this.settingsSavedData);
    },
    valueCanBeSaved(): boolean {
      return this.formValid && this.settingsChanged;
    }
  },
  watch: {
    operatorId: {
      handler: 'getConfiguration',
      immediate: true
    }
  },
  methods: {
    parseSettingsData(
      data: TCopyStakeSettingsElevenLabsConfigurationResponse
    ): void {
      const parsedData: TSettings = {
        elevenlabsApiKey: data.apiKey ?? ''
      };

      this.settingsSavedData = cloneDeep(parsedData);
      this.settings = cloneDeep(parsedData);
    },

    async getConfiguration(): Promise<void> {
      if (!this.operatorId) {
        return;
      }

      this.isLoading = true;

      getAiStreamerIntegrationElevenLabsConfiguration()
        .then((data: TCopyStakeSettingsElevenLabsConfigurationResponse) => {
          this.parseSettingsData(data);
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async updateConfiguration(): Promise<void> {
      const isFormValid = await (this.$refs.form as any).validate();
      if (!isFormValid) return;

      this.isLoading = true;

      const apiKey =
        this.settings.elevenlabsApiKey?.length > 0
          ? this.settings.elevenlabsApiKey
          : null;

      const payload: TCopyStakeSettingsElevenLabsConfigurationPayload = {
        apiKey
      };

      await updateAiStreamerIntegrationElevenLabsConfiguration(payload)
        .then((data: TCopyStakeSettingsElevenLabsConfigurationResponse) => {
          this.parseSettingsData(data);

          this.$toast.success(
            'AI Streamer Integration settings were successfully updated!'
          );
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
